"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var parts_1 = require("../components/parts");
var series_1 = require("../components/series");
var parts_2 = require("../components/Gantt/parts");
function default_1(children) {
    var childrenArray = react_1.default.Children.toArray(children);
    var timeSeriesChildren = childrenArray.reduce(function (types, child) {
        if (react_1.default.isValidElement(child)) {
            var type = child.type;
            switch (type) {
                case series_1.Line:
                    types.series.push(child);
                    break;
                case series_1.CandleStick:
                    types.series.push(child);
                    break;
                case series_1.Area:
                    types.series.push(child);
                    break;
                case series_1.AreaRange:
                    types.series.push(child);
                    break;
                case series_1.Column:
                    types.series.push(child);
                    break;
                case series_1.ColumnRange:
                    types.series.push(child);
                    break;
                case series_1.Bar:
                    types.series.push(child);
                    break;
                case series_1.Bullet:
                    types.series.push(child);
                    break;
                case series_1.Heatmap:
                    types.series.push(child);
                    types.includesHeatmap = true;
                    break;
                case series_1.Scatter:
                    types.series.push(child);
                    break;
                case series_1.Pie:
                    types.series.push(child);
                    break;
                case series_1.Gauge:
                    types.series.push(child);
                    break;
                case series_1.Donut:
                    types.series.push(child);
                    break;
                case parts_1.XAxis:
                    types.xAxis.push(child);
                    break;
                case parts_1.YAxis:
                    types.yAxis.push(child);
                    break;
                case parts_1.Legend:
                    types.legend = child;
                    break;
                case parts_1.Navigator:
                    types.navigator = child;
                    break;
                case parts_1.Credits:
                    types.credits = child;
                    break;
                case parts_1.RangeSelector:
                    types.rangeSelector = child;
                    break;
                case parts_1.Title:
                    types.title = child;
                    break;
                case parts_1.Tooltip:
                    types.tooltip = child;
                    break;
                case parts_1.Subtitle:
                    types.subtitle = child;
                    break;
                case parts_1.Pane:
                    types.pane.push(child);
                    break;
                case parts_1.PlotBand:
                    types.plotBands.push(child);
                    break;
                case parts_1.PlotLine:
                    types.plotLines.push(child);
                    break;
                case parts_2.TaskGroup:
                    types.taskGroups.push(child);
                    break;
                case parts_2.Task:
                    types.tasks.push(child);
                    break;
                default:
                    break;
            }
        }
        return types;
    }, {
        plotBands: [],
        series: [],
        plotLines: [],
        xAxis: [],
        yAxis: [],
        taskGroups: [],
        tasks: [],
        pane: [],
        includesHeatmap: false
    });
    return timeSeriesChildren;
}
exports.default = default_1;
//# sourceMappingURL=typeChildren.js.map